import { getPfFiles } from '@client-shared/api/pf-files.api'

export default {
  namespaced: true,

  state: () => {
    return {
      list: [],
    }
  },

  getters: {
    getById: (state) => {
      return pfFileId => state.list.find(pfFile => pfFile._id === pfFileId)
    },
  },

  mutations: {
    SET_PF_FILES (state, pfFiles) {
      state.list = pfFiles
    },

    RESET_LIST (state) {
      state.list = []
    },
  },

  actions: {
    async fetch ({ commit }, projectId) {
      try {
        const pfFiles = await getPfFiles({
          axios: this.$axios,
          projectId,
        })

        if (!pfFiles) {
          return
        }

        commit('SET_PF_FILES', pfFiles)
      } catch (err) {
        console.error(err)
      }
    },
  },
}
